var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 4.25a3.75 3.75 0 0 1 3.745 3.55l.005.2v8a3.75 3.75 0 0 1-3.55 3.745l-.2.005H6a3.75 3.75 0 0 1-3.745-3.55L2.25 16V8A3.75 3.75 0 0 1 5.8 4.255L6 4.25h12zm2.25 5.5H3.75V16a2.25 2.25 0 0 0 2.096 2.245L6 18.25h12a2.25 2.25 0 0 0 2.245-2.096L20.25 16V9.75zm-10.68 2.5a.75.75 0 0 1 .102 1.493l-.102.007H7a.75.75 0 0 1-.102-1.493L7 12.25h2.57zM18 5.75H6a2.25 2.25 0 0 0-2.245 2.096L3.75 8v.249h16.5V8a2.25 2.25 0 0 0-2.096-2.245L18 5.75z",
    fill: "#111827",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCreditCard);
export default __webpack_public_path__ + "static/media/icons-credit-card.d1b20a0094b6ce1d4b8f82698edbe232.svg";
export { ForwardRef as ReactComponent };